<div class="">
  <app-cue-table
      *ngIf="planReqtableDatasource"
      [dataset]="planReqtableDatasource"
      [gridOptions]="planReqtableConfigs"
      [columnDefinitions]="planReqtableColumnConfigs"
      [callback]="gridCallBacks"
      (onSelectionChanges)="onGridSelectionChanges($event)"
      (onTableCellClicked)="onCellClicked($event)"></app-cue-table>
</div>

<div class="footer rej_req pop_footer">
  <span class="align-right col-md-6 secondory_btn">
    <button class="btn btn-primary" (click)="onClose()">Close</button>
  </span>
</div>
